import { SCREEN_SIZE_DESKTOP, SCREEN_SIZE_LAPTOP, SCREEN_SIZE_MOBILE, SCREEN_SIZE_TABLET } from '@/config/variables';

interface ITheme {
  [key: string]: string | any;
}

const flex: ITheme = {
  centered: 'd-flex align-items-center justify-content-center',
  row: 'd-flex flex-row',
  rowCenter: 'd-flex flex-row align-items-center',
  rowReverse: 'd-flex flex-row-reverse',
  column: 'd-flex flex-column',
  columnCenter: 'd-flex flex-column justify-content-center',
  columnReverse: 'd-flex flex-column-reverse',
} as const;

const buttonType: ITheme = {
  primary: 'blue-outline',
  blue: 'blue',
  blueOutline: 'blue-outline',
  red: 'red',
  redOutline: 'red-outline',
} as const;

const sizing: ITheme = {
  fontSize: {
    sm: '14px',
    base: '16px',
    xxl: '2rem',
  },
  padding: {
    panelX: '24px',
    panelY: '24px',
  },
} as const;

const modals: ITheme = {
  width: {
    tablet: {
      s: '30vw',
      m: '40vw',
      l: '60vw',
    },
    desktop: {
      s: '500px',
      m: '700px',
      l: '1000px',
    },
  },
};

const customMediaQuery = (maxWidth: number): string => `@media (min-width: ${maxWidth}px)`;

const media = {
  custom: customMediaQuery,
  desktop: customMediaQuery(SCREEN_SIZE_DESKTOP),
  laptop: customMediaQuery(SCREEN_SIZE_LAPTOP),
  tablet: customMediaQuery(SCREEN_SIZE_TABLET),
  phone: customMediaQuery(SCREEN_SIZE_MOBILE),
};

export { buttonType, flex, media, sizing, modals };
